import React from "react"

import { HomeLink } from "./HomeLink"
import IconButton from "@mui/material/IconButton"
import MenuIcon from "@mui/icons-material/Menu"
import Box from "@mui/material/Box"
import CommentNotificationsButton from "./comments/CommentNotificationsButton"
import { MyLocationIcon } from "./components/CountryCityStateFetcher"
import { CompactTopBarView } from "react-ui-components/components/navigation/CompactTopBarView"
import { useNamespacedTranslation } from "./hooks/useNamespacedTranslation"
import { QrScannerLauncher } from "./toolbar/QrScannerLauncher"
import { VideoRouteButton } from "./toolbar/VideoRouteButton"
import { openLocationPopup } from "./utils/lazyPopups"

export const BottomToolbar: React.FC<{
  handleDrawerOpen?: React.MouseEventHandler<HTMLButtonElement>
  open: boolean
}> = ({ handleDrawerOpen, open }) => {
  const { t } = useNamespacedTranslation(["common"])
  const handleLocationClick = React.useCallback(() => {
    void openLocationPopup()
  }, [])

  const menuSlot = React.useMemo(
    () => (
      <IconButton
        color="inherit"
        aria-label="Open navigation menu"
        aria-expanded={open}
        edge="start"
        onClick={handleDrawerOpen}
        size="small"
        sx={{
          display: { xs: "flex", sm: "none" },
          minHeight: 36,
          minWidth: 36,
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
          "&:focus-visible": {
            outline: "2px solid currentColor",
            outlineOffset: "2px",
          },
        }}
      >
        <MenuIcon fontSize="small" />
      </IconButton>
    ),
    [handleDrawerOpen, open],
  )
  const navigationSlot = React.useMemo(
    () => (
      <Box sx={{ display: "grid", gridAutoFlow: "column", gridAutoColumns: "minmax(0, 1fr)", alignItems: "center", width: "100%", maxWidth: 600, mx: "auto", "& > div": { minWidth: 0 }, "& .MuiButtonBase-root": { minWidth: 0 }, "& .uppercase": { textAlign: "center", whiteSpace: "nowrap", letterSpacing: 0, "& > span": { fontSize: { xs: "clamp(6px, 2vw, 8px)", sm: 8 } } } }}>
        <HomeLink />
        <QrScannerLauncher />
        <VideoRouteButton />
        <CommentNotificationsButton />
        <MyLocationIcon onClick={handleLocationClick} label={t("location")} />
      </Box>
    ),
    [handleLocationClick, t],
  )

  return (
    <CompactTopBarView row="bottom" menuSlot={menuSlot} navigationSlot={navigationSlot} />
  )
}
